module.exports = __webpack_public_path__ + "images/ansvar3f851d7a03d1e8a4de2a2c9bff4c32f3.png";